/* global axios */
import ApiClient from './ApiClient';

const flowsClient = new ApiClient('flowbuilder/flows', { accountScoped: true });
const sessionsClient = new ApiClient('flowbuilder/sessions', {
  accountScoped: true,
});

export const flowbuilderAPI = {
  list: params => axios.get(flowsClient.url, { params }),
  show: id => axios.get(`${flowsClient.url}/${id}`),
  create: data => axios.post(flowsClient.url, { flow: data }),
  update: (id, data) => axios.patch(`${flowsClient.url}/${id}`, { flow: data }),
  delete: id => axios.delete(`${flowsClient.url}/${id}`),
  validate: (id, graph) =>
    axios.post(`${flowsClient.url}/${id}/validate`, { graph }),
  publish: id => axios.post(`${flowsClient.url}/${id}/publish`),
  rollback: (id, versionId) =>
    axios.post(`${flowsClient.url}/${id}/rollback`, { version_id: versionId }),
  pause: id => axios.post(`${flowsClient.url}/${id}/pause`),
  resume: id => axios.post(`${flowsClient.url}/${id}/resume`),
  execute: (id, entrypointId) =>
    axios.post(`${flowsClient.url}/${id}/execute`, {
      entrypoint_id: entrypointId,
    }),
  versions: (id, params = {}) =>
    axios.get(`${flowsClient.url}/${id}/versions`, { params }),
  sessions: (id, params = {}) =>
    axios.get(`${flowsClient.url}/${id}/sessions`, { params }),
  session: id => axios.get(`${sessionsClient.url}/${id}`),
  configureDiagnostics: data =>
    axios.post(`${sessionsClient.url}/diagnostics`, data),
};
